export default __webpack_public_path__ + "static/anchor-24a0ff99ca19461fd0c7254379fe9d88.png";